import React, { useState, useEffect } from 'react';

const WelcomeOnboarding = React.lazy(() =>
  import('./WelcomeOnboarding').then((m) => ({ default: m.WelcomeOnboarding }))
);

const WELCOME_KEY = 'hasSeenWelcome';

/**
 * Wrapper that conditionally displays the WelcomeOnboarding overlay
 * the first time any visitor opens the app in their browser.
 *
 * - If `hasSeenWelcome` is not set in localStorage, the onboarding overlay
 *   is shown — regardless of whether the visitor is logged in.
 * - Once dismissed, the flag is persisted and the overlay is suppressed on
 *   all subsequent visits in that browser.
 */
export function WelcomeOnboardingWrapper(): React.JSX.Element | null {
  const [showOnboarding, setShowOnboarding] = useState(false);

  useEffect(() => {
    const hasSeen = localStorage.getItem(WELCOME_KEY);
    if (!hasSeen) {
      setShowOnboarding(true);
    }
  }, []);

  function handleDismiss() {
    localStorage.setItem(WELCOME_KEY, 'true');
    setShowOnboarding(false);
  }

  if (!showOnboarding) return null;

  return (
    <React.Suspense fallback={null}>
      <WelcomeOnboarding onDismiss={handleDismiss} />
    </React.Suspense>
  );
}
